import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { UserBasicInfo, UsersByIdsInput } from '@erp/rpc';

export type { UserBasicInfo };

export function useUsersByIds(ids: string[], enabled = true) {
  const input: UsersByIdsInput = { ids };

  return useQuery<UserBasicInfo[]>({
    ...orpc.core.users.byIds.queryOptions({ input }),
    enabled: enabled && ids.length > 0,
  });
}
